import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to win and manage resources.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Many resources are won at the negotiating table. But who normally
                                                wins?</p>


                                            <div className="border_subtitle">A matter of economics</div>
                                            <div className="paraspace"><p>The true fundamental of economics is
                                                the designation of finite resources to a population. This
                                                happens in many amazing and mundane ways in different scenarios
                                                every day. But one scenario
                                                you might be more familiar with is the battle for resources
                                                within your workplace. Whether it is
                                                the latest piece of technology, the new intern, or face–time
                                                with stakeholders, there‘s often not
                                                enough to go around. Some of the most successful people in
                                                business are experts at not
                                                only garnering these key resources, but justifying their
                                                ownership of them by managing
                                                them effectively. The most common way of (fairly) acquiring
                                                these sorts of resources is at
                                                the negotiating table, and the study below will help give you an
                                                insight into some of the nuances
                                                of negotiating.</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">We all have to start
                                                    somewhere...
                                                </div>
                                                <p>In a 2011 study by Michelle Marks &amp; Crystal Howard,<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a> 149 new
                                                    recruits into a large field
                                                    of industries were studied for their use of negotiation in
                                                    starting salaries. It was found that
                                                    those who used negotiating tactics got a starting salary
                                                    $5000 higher, on average, than
                                                    those who used no negotiating techniques.</p>
                                                <p>The most successful were those who negotiated using competing
                                                    and collaborative
                                                    strategies. These are chacterised by an open and expansive
                                                    attitude and were more likely
                                                    to increase their salary by over $5000. Those who used
                                                    compromising strategies took less
                                                    on average, but still more than those who did not negotiate.
                                                    Interestingly, men were far
                                                    more likely to negotiate, and negotiate effectively, than
                                                    women, although the reason for this
                                                    was not clear. </p>

                                                <div className="uiheading"><p>To put it into perspective, if
                                                    someone negotiated a $55,000 starting salary rather than a
                                                    $50,000 salary, with an average 5% per year increase, they
                                                    would earn over half a million
                                                    more in a 40-year career than their colleague. So, it pays
                                                    to negotiate.</p>
                                                </div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}